import { Modal } from 'antd'
import { useTranslation } from 'translations'

const ModalMobileWarning = () => {
	const { t } = useTranslation()

	return (
		<Modal
			centered
			open
			footer={false}
			closable={false}
			title={t('notification')}
		>
			<p className="text-xl font-bold">
				{t('mobileRequired')}
			</p>
		</Modal>
	)
}

export default ModalMobileWarning